import { render, staticRenderFns } from "./ForceReservable.vue?vue&type=template&id=2c8e1580&"
import script from "./ForceReservable.vue?vue&type=script&lang=ts&"
export * from "./ForceReservable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports